 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"540d368284c0309328fe6a69263f055ac68e7a9d","3":"e387dfac7ff331721e462b4a421847c6f5f025eb","4":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","5":"45b8fa8f769eeaf30dce263ad16a43012959eb36","6":"8cb571fb712555b5543ea31367cbc028f1f27102","7":"b09b495f129397ad93099bc92dc172adf397a53f","8":"7490bd49aa53622910970b252a264e0dd9ced745","9":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","10":"f9beb1971ea41977cd67fb00c0ea9bc6705181bd","11":"fd113b4cd44afc312952b5152606df4c80fa1a9f","14":"7d59d357","16":"b778622a","17":"component---src-pages-404-jsx","18":"component---src-pages-about-jsx","19":"component---src-pages-accessibility-index-jsx","20":"component---src-pages-accessibility-statement-jsx","21":"component---src-pages-accolades-jsx","22":"component---src-pages-alternative-index-jsx","23":"component---src-pages-black-friday-dear-manager-jsx","24":"component---src-pages-black-friday-index-jsx","25":"component---src-pages-calculator-jsx","26":"component---src-pages-case-studies-jsx","27":"component---src-pages-cheatsheets-jsx","28":"component---src-pages-color-contrast-jsx","29":"component---src-pages-css-3-d-transform-examples-index-jsx","30":"component---src-pages-css-specificity-calculator-jsx","31":"component---src-pages-dear-manager-jsx","32":"component---src-pages-disclaimer-jsx","33":"component---src-pages-docs-changelog-jsx","34":"component---src-pages-docs-faq-jsx","35":"component---src-pages-docs-index-jsx","36":"component---src-pages-download-jsx","37":"component---src-pages-experimental-web-platform-features-jsx","38":"component---src-pages-exported-panes-jsx","39":"component---src-pages-for-llms-jsx","40":"component---src-pages-form-inspector-index-jsx","41":"component---src-pages-github-students-jsx","42":"component---src-pages-index-jsx","43":"component---src-pages-integrations-beinclusive-jsx","44":"component---src-pages-integrations-index-jsx","45":"component---src-pages-integrations-jetbrains-webstorm-jsx","46":"component---src-pages-integrations-markerio-jsx","47":"component---src-pages-integrations-toybox-systems-jsx","48":"component---src-pages-integrations-tumult-hype-jsx","49":"component---src-pages-integrations-tumult-whisk-jsx","50":"component---src-pages-legal-jsx","51":"component---src-pages-newsletter-jsx","52":"component---src-pages-opener-jsx","53":"component---src-pages-portal-index-jsx","54":"component---src-pages-pricing-index-jsx","55":"component---src-pages-pricing-quote-jsx","56":"component---src-pages-privacy-jsx","57":"component---src-pages-product-tour-jsx","58":"component---src-pages-quality-assurance-index-jsx","59":"component---src-pages-resources-jsx","60":"component---src-pages-screenshot-comparison-jsx","61":"component---src-pages-site-quality-index-jsx","62":"component---src-pages-snippets-index-jsx","63":"component---src-pages-social-media-previews-index-jsx","64":"component---src-pages-special-offers-jsx","65":"component---src-pages-support-index-jsx","66":"component---src-pages-syntax-jsx","67":"component---src-pages-tailwindcss-jsx","68":"component---src-pages-testimonials-jsx","69":"component---src-pages-thanks-jsx","70":"component---src-templates-blog-list-jsx","71":"component---src-templates-doc-jsx","72":"component---src-templates-post-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"6e4350186e7153148cec","2":"3da8a238265dd226ad68","3":"b9d00e951835a793c431","4":"01dbe1bee214d7cb848d","5":"e1f118a2bce4a451eb04","6":"ea45f0c499594fd4b252","7":"e3a3f4a7573b5ee59591","8":"36330fc6348005145245","9":"d7a8134d6c05ab6d4c48","10":"e06daa3a783f527a2302","11":"d64addabeec33dc9b3c7","13":"1cf456d915a15faffd8a","14":"0d75096431f29f0ab834","16":"43e99b6aeeae94600eca","17":"2039293182aa02438726","18":"15c4c08c6a5983ec1320","19":"5321e7cd7d72929a11db","20":"56fc7500c5998b4987ca","21":"073e673aa16bdf87158b","22":"8753e4b3975f865f59a4","23":"eea00d5de7ab49ab132f","24":"26c495a0052e659a322c","25":"23f5b330f60892b91407","26":"1837c0368776aa4a7bda","27":"a730a1a69955b6f0a3ae","28":"ac130d0fa89751c9fe55","29":"c92e2e13a23b830aebf3","30":"1a55830ae3525c47bccc","31":"ebe51d44c56038579f13","32":"383f231644d45f0b5be6","33":"1f595bb3955847e2c8a0","34":"59893b77400545b0132a","35":"96a6ebf37f0421b8f176","36":"f34ec84a0dfaebed71e3","37":"816e02ce9eb1e99c6bd4","38":"c3fe32710e1fb84a2625","39":"f5f53f3ccd5b648801de","40":"78755ac9036fcc30586d","41":"544ba420b18c8f8f4e2c","42":"97a9d6d19fb31ad46c52","43":"8c87bd90e8b92f004ba5","44":"3b50ab0674aab8764cb2","45":"9dd45df9a09563b1f473","46":"12056efc1a5d1db730b9","47":"2f766395fc94e03f9037","48":"23d121f1ab3b5cd33c63","49":"4f36686e3b3f4b78f3cb","50":"e3723f022a4338aec453","51":"db82fdd50d54bc8341e7","52":"bb8e2a95309a9238b7b9","53":"c32fc1220962ee068bea","54":"30ff94e8470476672c9a","55":"4a55604732156d840764","56":"2638992b6f5cdede44f2","57":"f9f4714d98ac66743041","58":"f8c3e7d03ac13044fb37","59":"5db769c6cfc459483d6d","60":"ca9220485eb668b4645c","61":"3fd2328cc63216abbc70","62":"4421e0ccfd72cc8e17bc","63":"71c1cd1e3baa507ccf1e","64":"fd8dd31447c77b83df18","65":"8d6ba7da45f304003e8e","66":"4ce06555648c4d2c09b6","67":"c4c52fdd66fe3bd6f6bf","68":"f36d52b840e38c222d01","69":"da507ed0200c38d35490","70":"539fa3e636a78e86897f","71":"55acc144f9616e8e73d0","72":"284a540d0765d56066e3","75":"0c41ea6b65f13ccbfc6d","76":"620f3e93681143457561","77":"d690aae91a41272f8ae1","78":"6e9ac9f45de8c8d429b6","79":"ee0818364ff4397bd525","80":"7e1e180fdc53e6269ce2","81":"4f702a97ababa4b1ad84","82":"3e466fbee930e6766c03","83":"1560dfd226870dc356fe"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"540d368284c0309328fe6a69263f055ac68e7a9d","3":"e387dfac7ff331721e462b4a421847c6f5f025eb","4":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","5":"45b8fa8f769eeaf30dce263ad16a43012959eb36","6":"8cb571fb712555b5543ea31367cbc028f1f27102","7":"b09b495f129397ad93099bc92dc172adf397a53f","8":"7490bd49aa53622910970b252a264e0dd9ced745","9":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","10":"f9beb1971ea41977cd67fb00c0ea9bc6705181bd","11":"fd113b4cd44afc312952b5152606df4c80fa1a9f","14":"7d59d357","16":"b778622a","17":"component---src-pages-404-jsx","18":"component---src-pages-about-jsx","19":"component---src-pages-accessibility-index-jsx","20":"component---src-pages-accessibility-statement-jsx","21":"component---src-pages-accolades-jsx","22":"component---src-pages-alternative-index-jsx","23":"component---src-pages-black-friday-dear-manager-jsx","24":"component---src-pages-black-friday-index-jsx","25":"component---src-pages-calculator-jsx","26":"component---src-pages-case-studies-jsx","27":"component---src-pages-cheatsheets-jsx","28":"component---src-pages-color-contrast-jsx","29":"component---src-pages-css-3-d-transform-examples-index-jsx","30":"component---src-pages-css-specificity-calculator-jsx","31":"component---src-pages-dear-manager-jsx","32":"component---src-pages-disclaimer-jsx","33":"component---src-pages-docs-changelog-jsx","34":"component---src-pages-docs-faq-jsx","35":"component---src-pages-docs-index-jsx","36":"component---src-pages-download-jsx","37":"component---src-pages-experimental-web-platform-features-jsx","38":"component---src-pages-exported-panes-jsx","39":"component---src-pages-for-llms-jsx","40":"component---src-pages-form-inspector-index-jsx","41":"component---src-pages-github-students-jsx","42":"component---src-pages-index-jsx","43":"component---src-pages-integrations-beinclusive-jsx","44":"component---src-pages-integrations-index-jsx","45":"component---src-pages-integrations-jetbrains-webstorm-jsx","46":"component---src-pages-integrations-markerio-jsx","47":"component---src-pages-integrations-toybox-systems-jsx","48":"component---src-pages-integrations-tumult-hype-jsx","49":"component---src-pages-integrations-tumult-whisk-jsx","50":"component---src-pages-legal-jsx","51":"component---src-pages-newsletter-jsx","52":"component---src-pages-opener-jsx","53":"component---src-pages-portal-index-jsx","54":"component---src-pages-pricing-index-jsx","55":"component---src-pages-pricing-quote-jsx","56":"component---src-pages-privacy-jsx","57":"component---src-pages-product-tour-jsx","58":"component---src-pages-quality-assurance-index-jsx","59":"component---src-pages-resources-jsx","60":"component---src-pages-screenshot-comparison-jsx","61":"component---src-pages-site-quality-index-jsx","62":"component---src-pages-snippets-index-jsx","63":"component---src-pages-social-media-previews-index-jsx","64":"component---src-pages-special-offers-jsx","65":"component---src-pages-support-index-jsx","66":"component---src-pages-syntax-jsx","67":"component---src-pages-tailwindcss-jsx","68":"component---src-pages-testimonials-jsx","69":"component---src-pages-thanks-jsx","70":"component---src-templates-blog-list-jsx","71":"component---src-templates-doc-jsx","72":"component---src-templates-post-jsx"}[chunkId]||chunkId) + "." + {"0":"5df57b0cdfa5d1a3cdda","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
